// extracted by mini-css-extract-plugin
export default {"widgetThemeColors":"styles_widgetThemeColors__WTFLe","checkbox":"styles_checkbox__FCDoW","colorInput":"styles_colorInput__Dm+oU"};